export default {"src":"https://fishbrain.com/_next/static/media/gearIcon.c4d7d924.svg","height":17,"width":32,"blurWidth":0,"blurHeight":0};